export default __webpack_public_path__ + "static/media/StackedBarChart.a346a4ba.svg";